import React from 'react';
import { Route, Switch } from 'react-router-dom';

import MasterForm from '../../../Upload/Master/index';
import MasterFormUpdate from '../../../Upload/MasterUpdate/index';
import BasePackFormUpdate from '../../../Upload/BasePackUpdate/index';
import CombinedProductFormUpdate from '../../../Upload/CombinedProductUpdate/index';
import CategoryFormUpdate from '../../../Upload/CategoryUpdate/index';
import alternateCreate from '../../../Upload/alternateCreate/index';
import alternateView from '../../../Upload/alternateView/index';




import AreaMasterFormUpdate from '../../../Upload/AreaMasterUpdate/index';
import BeatAreaMasterFormUpdate from '../../../Upload/BeatAreaMaster/index';

import RetailerMasterFormUpdate from '../../../Upload/RetailerMasterUpdate/index';
import OutletMasterFormUpdate from '../../../Upload/OutletMasterUpdate/index';
import RetailerProductMasterFormUpdate from '../../../Upload/RetailerProductMasterUpdate/index';
import RetailerOcldMasterFormUpdate from '../../../Upload/RetailerOcldMasterUpdate/index';
import HulAreaMasterFormUpdate from '../../../Upload/HulAreaMasterUpdate/index';
import ViewRetailerAreaMasterForm from '../../../Upload/ViewRetailerAreaMaster/index';
import PackingMasterFormUpdate from '../../../Upload/PackingMasterUpdate/index';

import ViewWarehouseMaster from '../../../Upload/ViewWarehouseMaster/index';
import ViewCityMaster from '../../../Upload/ViewCityMaster/index';
import ViewNewBrandMaster from '../../../Upload/ViewNewBrandMaster/index';
import ViewInventoryOwner from '../../../Upload/ViewInventoryOwner/index';


import ViewHulMasterForm from '../../../Upload/ViewHulMaster/index';
import ViewCategoryMasterForm from '../../../Upload/ViewCategoryMaster/index';
import ViewBasepackMasterForm from '../../../Upload/ViewBasepackMaster/index';
import ViewCombineProductMasterForm from '../../../Upload/ViewCombineProductMaster/index';
import ViewLBProductMasterForm from '../../../Upload/ViewLBProductMaster/index';


import ViewPackagingMasterForm from '../../../Upload/ViewPackagingMaster/index';
import ViewBeatAreaMasterForm from '../../../Upload/ViewBeatAreaMaster/index';
import ViewAreaMasterForm from '../../../Upload/ViewAreaMaster/index';
import ViewRetailerMasterForm from '../../../Upload/ViewRetailerMaster/index';
import ViewOutletMasterForm from '../../../Upload/ViewOutletMaster/index';
import ViewRetailerProductMasterForm from '../../../Upload/ViewRetailerProductMaster/index';
import ViewBrandMaster from '../../../Upload/ViewBrandMaster/index';
import ViewCategoryMasterJogeshwari from '../../../Upload/ViewCategoryMasterJogeshwari/index';
import ViewProductValidationMaster from '../../../Upload/ViewProductValidationMaster/index';
import ViewProductSubCategory from '../../../Upload/ViewProductSubCategory/index';
import ViewSku7Master from '../../../Upload/ViewSku7Master/index';
import ViewChildSkuMaster from '../../../Upload/ViewChildSkuMaster/index';
import ViewSku7MrpMaster from '../../../Upload/ViewSku7MrpMaster/index';
import UploadSubDivisonMaster from '../../../Upload/UploadSubDivisonMaster/index';
import UploadSubCategoryMaster from '../../../Upload/UploadSubCategoryMaster/index';
import UploadSku7Master from '../../../Upload/UploadSku7Master/index';
import UploadSku7MrpMaster from '../../../Upload/UploadSku7MrpMaster/index';
import UploadChildSkuMaster from '../../../Upload/UploadChildSkuMaster/index';
import UploadBrandMaster from '../../../Upload/UploadBrandMaster/index';
import UploadCategoryMaster from '../../../Upload/UploadCategoryMaster/index';
import ViewZoneMaster from '../../../Upload/ViewZoneMaster/index';
import UploadProductShelfLife from '../../../Upload/UploadProductShelfLife/components/UploadProductShelfLife';



















export default () => (
  <Switch>
    <Route path="/upload/master_form" component={MasterForm} />
	<Route path="/upload/master_form_update" component={MasterFormUpdate} />
	<Route path="/upload/basepack_form_update" component={BasePackFormUpdate} />
	<Route path="/upload/alternate_product_create" component={alternateCreate} />
	<Route path="/upload/alternate_product_view" component={alternateView} />

	<Route path="/upload/category_form_update" component={CategoryFormUpdate} />

	<Route path="/upload/combined_product_form_update" component={CombinedProductFormUpdate} />
	<Route path="/upload/packing_master_form_update" component={PackingMasterFormUpdate} />

	<Route path="/upload/area_master_form_update" component={AreaMasterFormUpdate} />
	<Route path="/upload/beat_area_master_form_update" component={BeatAreaMasterFormUpdate} />
	<Route path="/upload/retailer_master_form_update" component={RetailerMasterFormUpdate} />
	<Route path="/upload/outlet_master_form_update" component={OutletMasterFormUpdate} />
	<Route path="/upload/retailer_product_master_form_update" component={RetailerProductMasterFormUpdate} />
	<Route path="/upload/retailer_ocld_master_form_update" component={RetailerOcldMasterFormUpdate} />
	<Route path="/upload/hul_area_master_form_update" component={HulAreaMasterFormUpdate} />



	<Route path="/upload/view_basepack_master_form" component={ViewBasepackMasterForm} />
	<Route path="/upload/view_combined_product_master_form" component={ViewCombineProductMasterForm} />
	<Route path="/upload/view_lb_product_master_form" component={ViewLBProductMasterForm} />
	<Route path="/upload/view_packaging_master_form" component={ViewPackagingMasterForm} />

	<Route path="/upload/view_warehouse_master" component={ViewWarehouseMaster} />
	<Route path="/upload/view_city_master" component={ViewCityMaster} />
	<Route path="/upload/view_new_brand_master" component={ViewNewBrandMaster} />
	<Route path="/upload/view_inventory_owner" component={ViewInventoryOwner} />


	<Route path="/upload/view_category_master_form" component={ViewCategoryMasterForm} />
	<Route path="/upload/view_area_master_form" component={ViewAreaMasterForm} />
	<Route path="/upload/view_beat_area_master_form" component={ViewBeatAreaMasterForm} />

	<Route path="/upload/view_hul_master_form" component={ViewRetailerAreaMasterForm} />
	<Route path="/upload/view_hul_master_form" component={ViewHulMasterForm} />
	<Route path="/upload/view_retailer_master_form" component={ViewRetailerMasterForm} />
	<Route path="/upload/view_outlet_master_form" component={ViewOutletMasterForm} />
	<Route path="/upload/view_retailer_product_master_form" component={ViewRetailerProductMasterForm} />
	<Route path="/upload/view_brand_master" component={ViewBrandMaster} />
	<Route path="/upload/view_category_master" component={ViewCategoryMasterJogeshwari} />
	<Route path="/upload/view_product_validation_master" component={ViewProductValidationMaster} />
	<Route path="/upload/view_product_sub_category_master" component={ViewProductSubCategory} />
	<Route path="/upload/view_sku7_master" component={ViewSku7Master} />
	<Route path="/upload/view_child_sku_master" component={ViewChildSkuMaster} />
	<Route path="/upload/view_sku_mrp_Master" component={ViewSku7MrpMaster} />
	<Route path="/upload/view_zone_master" component={ViewZoneMaster} />

	<Route path="/upload/upload_brand_master" component={UploadBrandMaster} />
	<Route path="/upload/upload_category_master" component={UploadCategoryMaster} />
	<Route path="/upload/upload_product_validation_master" component={UploadSubDivisonMaster} />
	<Route path="/upload/upload_product_sub_category_master" component={UploadSubCategoryMaster} />
	<Route path="/upload/upload_sku7_master" component={UploadSku7Master} />
	<Route path="/upload/upload_child_sku_master" component={UploadChildSkuMaster} />
	<Route path="/upload/upload_sku_mrp_Master" component={UploadSku7MrpMaster} />
	<Route path="/upload/upload_product_shelf_life" component={UploadProductShelfLife} />
   
  </Switch>
);
